module.exports = __webpack_public_path__ + "static/media/adult.7d021e3f.svg";